import { CfFlowResponse, useGetCfFlowQuery } from './api/cloudflareFlowApi';

export type CfResumeFlowState = {
  flow: CfFlowResponse | undefined;
  isLoading: boolean;
  isMissing: boolean;
  isUnavailable: boolean;
};

/**
 * Reads the flow behind a resumed mount, deliberately without a poll of its own:
 * the step already holds one polling reader of this cache entry, and a timer
 * here would be a second one.
 */
export const useCfResumeFlow = (
  enabled: boolean,
  domain: string | null,
): CfResumeFlowState => {
  const { data, isLoading, error } = useGetCfFlowQuery(
    { domain: domain ?? '' },
    { skip: !enabled || !domain },
  );

  const isMissing = Boolean(error && 'status' in error && error.status === 404);

  return {
    flow: data,
    isLoading,
    isMissing,
    isUnavailable: Boolean(error) && !isMissing,
  };
};
